export default "__VITE_ASSET__DUVeJivM__"